<div class="portlet light">
  <div class="portlet-title news">
    <div class="caption caption-md">
      <span class="caption-subject">Latest news</span>
    </div>
  </div>

  <div class="portlet-body portlet-scrolls">
    <div>
      <div class="row custom-upper-space">
        <div class="col-md-6 mgtbottom news-container" *ngFor="let item of newsList">
          <span class="datetext">{{ item.date | date : 'EEE, d MMM YYYY' }} </span>
          <div class="mb-3" (click)="openAdditionalInfo(item)">
            <span class="subject-txt">
              {{ item.subject }}
            </span>
          </div>
          <span class="newstext" [innerHTML]="trimString(item.description, 150)"> </span>
          <div class="showMoretext" *ngIf="item.description.length > 150">
            <span (click)="openAdditionalInfo(item)">See More...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
